import React from "react";

function ExamplePage() {
	return <>404</>;
}

export default ExamplePage;
